/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { InputFieldDef } from '@app/common/types/input-field-def';

export const AdvSearchFieldDef = new Map<string, InputFieldDef>([
  [
    'patientName',
    {
      inputType: 'patientName',
      searchCharLimit: 41,
      minChars: 2,
      label: 'searchModule.lastFirstNameLabel' // this is for error notification
    }
  ],
  [
    'mrn',
    {
      inputType: 'mrn',
      searchCharLimit: 64,
      minChars: 2,
      minPrefixChars: 3,
      suffixChars: 4,
      specialCharacters: new RegExp("[^0-9a-zA-ZàáâãäçèéêëìíîïñòóôõöùúûüÀÁÂÃÄÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜß\\s_*,'%+$#^.-]+"),
      allowPrefixSearch: true,
      allowSuffixSearch: true,
      label: 'searchModule.mrnPatientIdLabel'
    }
  ],
  [
    'nhi',
    {
      inputType: 'nhi',
      searchCharLimit: 64,
      specialCharacters: new RegExp('[^0-9]+'),
      allowPrefixSearch: false,
      allowSuffixSearch: false,
      label: 'searchModule.mrnPatientIdNHILabel'
    }
  ],
  [
    'accession',
    {
      inputType: 'accession',
      searchCharLimit: 32,
      minChars: 2,
      minPrefixChars: 3,
      specialCharacters: new RegExp("[^0-9a-zA-Z\\s_*'%+,$^#.-]+"),
      allowPrefixSearch: true,
      allowSuffixSearch: false,
      label: 'searchModule.accessionNumberLabel'
    }
  ],
  [
    'orderNumber',
    {
      inputType: 'orderNumber',
      searchCharLimit: 64,
      minChars: 2
    }
  ],
  [
    'worklistName',
    {
      inputType: 'worklistName',
      searchCharLimit: 50,
      specialCharacters: new RegExp('[^0-9a-zA-ZàáâãäçèéêëìíîïñòóôõöùúûüÀÁÂÃÄÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜß\\s_.-]+')
    }
  ],
  [
    'departmentId',
    {
      inputType: 'departmentId',
      searchCharLimit: 32,
      specialCharacters: new RegExp('[^0-9]+')
    }
  ],
  [
    'orderingLocationId',
    {
      inputType: 'orderingLocationId',
      searchCharLimit: 32,
      specialCharacters: new RegExp('[^0-9]+')
    }
  ]
]);
